module.exports = __webpack_public_path__ + "media/images/common/clear_btn_l_ov-9ec82188ce728787c16886e1cb8cb9ba.png";